import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Loader2, X } from "lucide-react";
import { decideOrder, fetchPendingOrders, ron } from "@/lib/bf";

const unesc = (t) => new DOMParser().parseFromString(t.replace(/<br\s*\/?>/g, " "), "text/html").documentElement.textContent;

export default function BFPendingOrders() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { fetchPendingOrders().then(setRows).catch(() => setRows([])); }, []);
  if (!rows?.length) return null;
  const act = (r, a) => {
    setBusy(r.id);
    decideOrder(r.id, a).then((d) => { setRows((l) => l.filter((x) => x.id !== r.id)); toast.success(a === "approve" ? `Aprobată · proforma ${d.pf.no}` : "Comandă respinsă"); })
      .catch(() => toast.error("Nu am putut procesa")).finally(() => setBusy(""));
  };
  return (
    <section className="invite-box" data-testid="bf-pending-orders">
      <h3>Comenzi agenți care așteaptă aprobare ({rows.length})</h3>
      <ul className="bf-pend">
        {rows.map((r) => (
          <li key={r.id} data-testid={`bf-pending-${r.id}`}>
            <div><b>{r.salon}</b> · {r.agent_name} · {ron(r.total)}<small>{unesc(r.notes.slice(0, 2).join(" · "))}</small>
              <small>{r.items.map((i) => `${i.q}× ${i.name} (${ron(i.unit)})`).join("; ")}</small></div>
            <div className="share-actions">
              <button type="button" className="st-btn st-btn--light" disabled={busy === r.id} onClick={() => act(r, "approve")} data-testid={`bf-pending-approve-${r.id}`}>{busy === r.id ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} Aprobă</button>
              <button type="button" className="st-btn st-btn--ghost" disabled={busy === r.id} onClick={() => act(r, "reject")} data-testid={`bf-pending-reject-${r.id}`}><X size={14} /> Respinge</button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
